// extracted by mini-css-extract-plugin
export default {"cls1":"CvR3O1ddl8XgL4Q29MWt","cls2":"H548gIG7m_CgrVBg3HEI CvR3O1ddl8XgL4Q29MWt"};